const STORAGE_KEY = 'kalvantisWishlist';
const PAGE_PATH = '/pages/wishlist';

function mountWishlistDrawer() {
  const drawer = document.querySelector('theme-drawer#kalvantis-wishlist');
  if (!drawer || drawer.dataset.wishlistMounted === 'true') return;

  document.body.appendChild(drawer);
  drawer.dataset.wishlistMounted = 'true';
}

function readWishlist() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function writeWishlist(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function isSaved(url) {
  return readWishlist().some((item) => item.url === url);
}

function toggleWishlist(product) {
  const items = readWishlist();
  const existingIndex = items.findIndex((item) => item.url === product.url);

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  } else {
    items.unshift(product);
  }

  writeWishlist(items);
  syncWishlistUI();
}

function getProductData(button) {
  const card = button.closest('[data-kv-product-card]');
  const json = card?.querySelector('[data-kv-product-json]');
  if (!json) return null;

  try {
    const product = JSON.parse(json.textContent || '{}');
    return {
      id: product.id,
      title: product.title,
      url: product.url,
      price: product.price,
      image: product.featuredImage || product.secondaryImage || '',
      available: product.available,
    };
  } catch {
    return null;
  }
}

function renderWishlistCards(items) {
  return items
    .map(
      (item) => `
        <article class="kalvantis-wishlist__card" data-wishlist-url="${item.url}">
          <a class="kalvantis-wishlist__media" href="${item.url}">
            ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
          </a>
          <div class="kalvantis-wishlist__content">
            <a class="kalvantis-wishlist__title" href="${item.url}">${item.title}</a>
            <p class="kalvantis-wishlist__price">${item.price || ''}</p>
            <div class="kalvantis-wishlist__actions">
              <a class="kalvantis-wishlist__view" href="${item.url}">View product</a>
              <button class="kalvantis-wishlist__remove" type="button" data-wishlist-remove="${item.url}">Remove</button>
            </div>
          </div>
        </article>
      `
    )
    .join('');
}

function renderWishlistDrawer(container, items) {
  const itemLabel = `${items.length} ${items.length === 1 ? 'item' : 'items'} saved`;

  if (!items.length) {
    container.innerHTML = `
      <div class="kalvantis-wishlist-drawer__layout">
        <div class="kalvantis-wishlist-drawer__intro">
          <p class="kalvantis-wishlist__eyebrow">Saved edit</p>
          <h3>Nothing saved yet.</h3>
          <p>Tap the heart on any scrub to keep it here for later comparison.</p>
        </div>
        <div class="kalvantis-wishlist__empty kalvantis-wishlist__empty--drawer">
          <a class="kalvantis-wishlist__cta" href="/collections/all">Explore products</a>
        </div>
      </div>
    `;
    return;
  }

  container.innerHTML = `
    <div class="kalvantis-wishlist-drawer__layout">
      <div class="kalvantis-wishlist-drawer__intro">
        <p class="kalvantis-wishlist__eyebrow">Saved edit</p>
        <div class="kalvantis-wishlist-drawer__meta">
          <h3>Your shortlist</h3>
          <span class="kalvantis-wishlist-drawer__count">${itemLabel}</span>
        </div>
        <p>Keep the pieces you want close, then step back into the product when you're ready.</p>
      </div>
      <div class="kalvantis-wishlist-drawer__items">
        ${renderWishlistCards(items)}
      </div>
      <div class="kalvantis-wishlist-drawer__footer">
        <a class="kalvantis-wishlist__secondary" href="/collections/all">Continue shopping</a>
        <a class="kalvantis-wishlist__cta" href="${PAGE_PATH}">Open wishlist page</a>
      </div>
    </div>
  `;
}

function renderWishlistItems(container, items) {
  if (!container) return;

  if (container.closest('.kalvantis-wishlist-drawer__body')) {
    renderWishlistDrawer(container, items);
    return;
  }

  if (!items.length) {
    container.innerHTML = `
      <div class="kalvantis-wishlist__empty">
        <p class="kalvantis-wishlist__eyebrow">Saved items</p>
        <h2>Your wishlist is empty.</h2>
        <p>Save pieces you want to come back to and build your clinical edit.</p>
        <a class="kalvantis-wishlist__cta" href="/collections/all">Explore products</a>
      </div>
    `;
    return;
  }

  container.innerHTML = renderWishlistCards(items);
}

function renderWishlistPage() {
  mountWishlistDrawer();

  if (window.location.pathname !== PAGE_PATH) return;

  const drawer = document.querySelector('theme-drawer#kalvantis-wishlist');
  drawer?.removeAttribute('open');
  drawer?.setAttribute('hidden', '');
  drawer?.querySelector('dialog')?.removeAttribute('open');

  const main = document.querySelector('#MainContent');
  if (!main) return;

  const items = readWishlist();
  const itemLabel = `${items.length} ${items.length === 1 ? 'item' : 'items'} saved`;

  main.innerHTML = `
    <section class="kalvantis-wishlist-page">
      <div class="kalvantis-wishlist-page__inner">
        <div class="kalvantis-wishlist-page__main">
          <header class="kalvantis-wishlist-page__header">
            <p class="kalvantis-wishlist__eyebrow">Wishlist</p>
            <h1>Saved for later.</h1>
            <p>Keep your preferred scrubs in one quiet shortlist and step back into any style when you're ready.</p>
          </header>
          <div class="kalvantis-wishlist-page__panel">
            <div class="kalvantis-wishlist-page__grid" data-wishlist-items></div>
          </div>
        </div>
        <aside class="kalvantis-wishlist-page__summary">
          <div class="kalvantis-wishlist-page__summary-card">
            <p class="kalvantis-wishlist__eyebrow">Your shortlist</p>
            <h2>Keep your edit close.</h2>
            <p>Compare saved styles, reopen product pages, and move forward when you're ready.</p>
            <span class="kalvantis-wishlist-page__count" data-wishlist-page-count>${itemLabel}</span>
            <div class="kalvantis-wishlist-page__summary-actions">
              <a class="kalvantis-wishlist__cta" href="/collections/all">Explore products</a>
              <a class="kalvantis-wishlist__secondary" href="/collections/all">Continue shopping</a>
            </div>
          </div>
        </aside>
      </div>
    </section>
  `;

  document.title = 'Wishlist - Kalvantis';
  renderWishlistItems(main.querySelector('[data-wishlist-items]'), items);
}

function syncButtons() {
  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    const product = getProductData(button);
    if (!product) return;

    const active = isSaved(product.url);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${product.title} ${active ? 'from' : 'to'} wishlist`);
  });
}

function syncCounts() {
  const count = readWishlist().length;
  document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
    node.textContent = String(count);
    node.hidden = count === 0;
  });

  document.querySelectorAll('[data-wishlist-page-count]').forEach((node) => {
    node.textContent = `${count} ${count === 1 ? 'item' : 'items'} saved`;
  });
}

function syncDrawers() {
  const items = readWishlist();
  document.querySelectorAll('[data-wishlist-items]').forEach((container) => renderWishlistItems(container, items));
}

function syncWishlistUI() {
  mountWishlistDrawer();
  syncButtons();
  syncCounts();
  syncDrawers();
}

function openWishlistDrawer() {
  mountWishlistDrawer();
  const drawer = document.querySelector('theme-drawer#kalvantis-wishlist');
  drawer?.removeAttribute('hidden');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  }
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-wishlist-trigger]');
  if (trigger) {
    event.preventDefault();
    if (window.location.pathname === PAGE_PATH) return;
    openWishlistDrawer();
    return;
  }

  const button = event.target.closest('[data-wishlist-button]');
  if (button) {
    event.preventDefault();
    const product = getProductData(button);
    if (product) toggleWishlist(product);
    return;
  }

  const remove = event.target.closest('[data-wishlist-remove]');
  if (remove) {
    event.preventDefault();
    const url = remove.getAttribute('data-wishlist-remove');
    writeWishlist(readWishlist().filter((item) => item.url !== url));
    syncWishlistUI();
  }
});

window.addEventListener('storage', syncWishlistUI);

renderWishlistPage();
syncWishlistUI();
